export default {"src":"/_next/static/media/arrow-right-black.e162891c.svg","height":24,"width":34};